import React from "react";
import { Sparkles } from "lucide-react";
import { STEPS } from "./constants";

export function StepPicker({ step, onPick, onBack }) {
  const current = STEPS[step];
  return (
    <>
      <div className="flex items-center gap-2 mb-2">
        <Sparkles size={14} className="text-[#C8A96E]" />
        <span className="text-[10px] uppercase tracking-[0.32em] text-[#C8A96E]">Turn Your Map Into Your Journey</span>
      </div>
      <h2 className="font-heading text-3xl sm:text-4xl text-white leading-tight" data-testid="wellness-title">Plan My Wellness Trip</h2>
      <p className="mt-2 text-sm text-[#A89C98]">Step {step + 1} of {STEPS.length}</p>

      <div className="mt-6" data-testid={`wellness-step-${current.field}`}>
        <h3 className="text-lg text-white mb-4">{current.label}</h3>
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
          {current.options.map((opt) => (
            <button
              key={opt.key}
              data-testid={`wellness-option-${current.field}-${opt.key}`}
              onClick={() => onPick(current.field, opt.key)}
              className="group relative rounded-xl border border-[#C8A96E]/30 bg-[#15111A]/60 hover:border-[#C8A96E] hover:bg-[#C8A96E]/10 transition-all p-4 text-left"
            >
              {opt.icon && <opt.icon size={18} className="text-[#C8A96E] mb-2" />}
              <div className="text-sm text-white group-hover:text-[#C8A96E] transition-colors">{opt.label}</div>
            </button>
          ))}
        </div>
      </div>

      {step > 0 && (
        <button data-testid="wellness-back-btn" onClick={onBack} className="mt-6 text-xs text-[#A89C98] hover:text-white">← Back</button>
      )}
    </>
  );
}
